import { createAsyncThunk } from "@reduxjs/toolkit";
import { CasesBonus, CasesBonusGlobal, CasesBonusResponse } from "../../../entities/cases_v2";
import { agent } from "../../../api";
import { casesUrl } from "../casesReducer";
import { addNotification } from "../../Notification/notificateStore";
import { handlerNeedUpdate } from "../casesTableStore";

export const getCasesBonus = createAsyncThunk(
  "cases/get-case-by-id",
  async (param: { id: number }): Promise<CasesBonus> => {
    try {
      const response = await agent.get(`${casesUrl}/bonus/read/${param.id}`);
      if (response.ok) {
        const data = (await response.json()) as CasesBonus;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postCasesBonus = createAsyncThunk(
  "cases/post-case-bonus",
  async (params: { data: CasesBonusGlobal }, thunksApi) => {
    try {
      const response = await agent.post(
        `${casesUrl}/bonus/create/from-global-settings`,
        {
          body: JSON.stringify(params.data),
        }
      );
      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }
    } catch (error) { }
  }
);

export const patchCasesBonus = createAsyncThunk(
  "cases/patch-case-bonus",
  async (params: { data: CasesBonusResponse, id: number }, thunksApi) => {
    try {
      const response = await agent.patch(`${casesUrl}/bonus/update/from-config-part/${params.id}`, {
        body: JSON.stringify(params.data),
      })

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
        return data;
      }

      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }
    } catch (error) {

    }
  }
);